import React, { Fragment, useEffect, useMemo, useState } from 'react';
import Layout from '../../Layout';
import BreadcrumbBlock from '../../components/BreadcrumbBlock/BreadcrumbBlock';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ConfigProvider, Pagination, Switch, Tabs, TabsProps, PaginationProps } from 'antd';
import { EyeOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { AllCommunityModule, ColDef, ModuleRegistry } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import './VouchersManagement.scss'
import VoucherFilterBlock from './VoucherComponents/VoucherFilterBlock';
import EmptyComponent from '../../components/EmptyComponent/EmptyComponent';
import viVN from 'antd/locale/vi_VN';
import useToast from '../../hook/useToast';
import { dataPagination, formatPrice, getPermissionClass, getUserPermissions } from '../../until';
import useDebounce from '../../hook/useDebounce';
import * as voucherApi from '../../api/voucher/voucherApi';
import * as XLSX from 'xlsx';
import useThrottle from '../../hook/useThrottle';
import ModalDeleteManager from '../../components/ModalDeleteManager';
import { formatNumber } from '../../services/mixin';
import useLoading from '../../hook/useLoading';
import { statusVoucher, typeVoucher, VoucherAction, VoucherDetailStatusEnum } from '../../services/data';
import { RoleType } from './VoucherCreate';
import dayjs from 'dayjs';
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useSelector } from 'react-redux';
import { selectorPermission } from '../../store/slices/permissionSlice';

dayjs.extend(customParseFormat);

ModuleRegistry.registerModules([AllCommunityModule]);

const STATUS_CONFIG: Record<number, { label: string; color: string }> = {
  0: { label: 'Nháp', color: '#8C8C8C' },
  1: { label: 'Chờ duyệt', color: '#FA8C16' },
  2: { label: 'Chờ kích hoạt', color: '#1890FF' },
  3: { label: 'Đang hoạt động', color: '#52C41A' },
  4: { label: 'Tạm dừng', color: '#FAAD14' },
  5: { label: 'Từ chối', color: '#F5222D' },
  6: { label: 'Đã kết thúc', color: '#8C8C8C' },
};

export interface IDataVocher {
  active: voucherApi.IVoucher[],
  finished: voucherApi.IVoucher[],
  comingSoon: voucherApi.IVoucher[],
}

const VouchersManagement: React.FC = () => {
  useEffect(() => {
    document.title = 'THACO AUTO CRM';

    // uStatusVoucher()
    return (() => {

      setIsModalDelete(false)

      setSelectedTab("1")

      setDataFilter({
        name: "",
        date: ["", ""]
      })

      setPaginationActive({ current: 1, pageSize: 10, total: 0 })
    })

  }, []);

  const pushToast = useToast();
  const pushLoading = useLoading()
  const navigate = useNavigate()
  const location = useLocation()

  const permissionSlice = useSelector(selectorPermission)
  const { add, edit, delete: isDelete, download } = getUserPermissions(permissionSlice, location.pathname)

  const { unitIdVoucher: issuedUnitId, dataFilterVoucher, firstPage } = location?.state ?? {}

  const [isModalnDelete, setIsModalDelete] = useState(false)

  const [selectedTab, setSelectedTab] = useState<"0" | "1" | "2">("1");

  const [dataFilter, setDataFilter] = useState({ name: "", date: ["", ""] }
  )

  const [paginationActive, setPaginationActive] = useState({ current: 1, pageSize: 10, total: 0 });

  const [idVoucher, setIdVoucher] = useState<number>()

  const [listVoucherActive, setListVoucherActive] = useState<voucherApi.IVoucher[]>([])


  const gListVocherActive = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    pushLoading(true)
    const result = await voucherApi.getListVoucher(
      pageSize, pageCurent, issuedUnitId, dataFilter.name,
      dataFilter.date[0], dataFilter.date[1]
    )
    if (result?.status) {
      setListVoucherActive(result.data)
      setPaginationActive({ current: pageCurent, total: result.total, pageSize })
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }, 1000)

  const editStatusVoucher = async (id: number, status?: number, approvalNote?: string) => {
    pushLoading(true)

    const result = await voucherApi.updateStatusVoucher(id, status, approvalNote)
    if (result?.status) {
      // setInfoVoucher(result.data)
      gListVocherActive()
      pushToast(result?.message, "success")

    } else {
      pushToast(result?.message, "warning")

    }
    pushLoading(false)

  }

  const onChangeActive = useThrottle(async (data: voucherApi.IVoucherEdit) => {
    const start = dayjs(
      `${data?.dateStart} ${data?.timeStart}`,
      "DD/MM/YYYY HH:mm"
    );

    const end = dayjs(
      `${data?.dateEnd} ${data?.timeEnd}`,
      "DD/MM/YYYY HH:mm"
    );

    const now = dayjs();
    switch (data?.status) {
      case VoucherDetailStatusEnum.ACTIVE:
        editStatusVoucher(data.id, VoucherAction.PAUSE)
        break;
      case VoucherDetailStatusEnum.PAUSED:
        console.log('object1')

        if (start.isBefore(now) && end.isAfter(now)) {
          console.log('object2')
          editStatusVoucher(data.id, VoucherAction.RESUME);
        }
        break;

      default:
        break;
    }
  }, 2000)

  // const uStatusVoucher = useThrottle(async () => {
  //   await voucherApi.updateStatusVoucher()
  // }, 10000)

  const exportExcel = (convertData: any): boolean => {
    try {
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(convertData);
      const workbook: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Danh sách');

      const excelBuffer: ArrayBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });

      const saveAsExcel = (buffer: ArrayBuffer, fileName: string): void => {
        const data: Blob = new Blob([buffer], { type: 'application/octet-stream' });
        const link: HTMLAnchorElement = document.createElement('a');
        link.href = window.URL.createObjectURL(data);
        link.download = fileName;
        link.click();
      };

      saveAsExcel(excelBuffer, `${"Danh sách voucher"}.xlsx`);
      return true;
    } catch (error) {
      console.error('Error exporting Excel:', error);
      return false;
    }
  }


  const onPaginationChangeActive: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    gListVocherActive(pageNumber, pageSize)
  }

  const openModalDelete = (id: number) => {
    setIdVoucher(id)
    setIsModalDelete(true)
  }

  const closeModalDelete = () => {
    setIdVoucher(undefined)
    setIsModalDelete(false)
  }

  const onConfirmDelete = async () => {
    const result = await voucherApi.deleteVoucher(Number(idVoucher))
    if (result?.status) {
      pushToast(result.message, "success")
      closeModalDelete()
      gListVocherActive()

    } else {
      pushToast(result?.message, "warning")
    }
  }

  const columnDefs = useMemo<ColDef<voucherApi.IVoucher>[]>(() => [
    {
      headerName: 'Hành động',
      field: 'id',
      resizable: false,
      sortable: false,
      width: 200,
      lockPosition: 'left',
      cellRenderer: (params: any) => (
        <div className="custom-page-css flex gap-2 items-center justify-center h-full">
          <EyeOutlined
            className="custom-page-css text-sm border-D9D9D9 p-5-px bg-white rounded cursor-pointer"
            onClick={() => navigate('/marketing/vouchers-management/access', { state: { id: params.data.id } })}
          />

          {params.data.status === VoucherDetailStatusEnum.DRAFT &&
            <>
              <EditOutlined
                className={`${getPermissionClass(edit)} custom-page-css text-F5222D text-sm border-EAECF0 p-5-px bg-white rounded cursor-pointer`}

                onClick={() => navigate('/marketing/vouchers-management/edit', { state: { id: params.data.id } })}
              />
              <DeleteOutlined
                className={`${getPermissionClass(isDelete)} custom-page-css text-F5222D text-sm border-EAECF0 p-5-px bg-white rounded cursor-pointer`}
                onClick={() => openModalDelete(params.data.id)}
              />
            </>
          }
          <Switch
            value={params.data.status === VoucherDetailStatusEnum.ACTIVE ? true : false}
            className="rs-switch rs-switch--sm"
            onClick={() => onChangeActive(params.data)}
          />
        </div>
      ),
    },
    {
      headerName: 'Mã chương trình voucher',
      field: 'code',
    },
    {
      headerName: 'Tên chương trình voucher',
      field: 'title',
    },
    {
      headerName: 'Trạng thái',
      field: 'status',
      cellRenderer: (params: any) => {
        const config = STATUS_CONFIG[params.value] ?? { label: 'Không xác định', color: '#8C8C8C' }
        return (
          <div className="d-flex align-center gap-1 h-full">
            <span style={{ width: 8, height: 8, borderRadius: '50%', background: config.color, display: 'inline-block', flexShrink: 0 }} />
            <span>{config.label}</span>
          </div>
        )
      },
    },
    {
      headerName: 'Loại hình',
      field: 'type',
      // cellRenderer: (params: any) => typeVoucher.find(t => t.Value === params.value)?.label ?? '',
    },
    {
      headerName: 'Thời gian bắt đầu',
      field: 'dateStart',
      sortable: true,
    },
    {
      headerName: 'Thời gian bắt đầu thực tế',
      field: 'approvalDate',
      sortable: true,
    },
    {
      headerName: 'Thời gian hết hiệu lực',
      field: 'dateEnd',
      sortable: true,
    },

    {
      headerName: 'Mô tả',
      field: 'description',
      sortable: true,
    },
    {
      headerName: 'Số lượng voucher phát hành',
      field: 'quantity',
      sortable: true,
      cellRenderer: (params: any) => (
        <span>{formatNumber(params.value)}</span>
      ),
    },
    {
      headerName: 'Số lượng voucher đã phát hành',
      field: 'releasedQuantity',
      sortable: true,
      cellRenderer: (params: any) => (
        <span>{formatNumber(params.value)}</span>
      ),
    },
    {
      headerName: 'Đã đổi',
      field: 'redeemedVoucherQuantity',
      sortable: true,
      cellRenderer: (params: any) => (
        <span>{formatNumber(params.value)}</span>
      ),
    },
    {
      headerName: 'Số lần áp dụng cho từng khách hàng',
      field: 'usageCount',
      cellRenderer: (params: any) => (
        <span>{formatNumber(params.value)}</span>
      ),
      sortable: true,
    },

    {
      headerName: 'Hình thức giảm',
      field: 'role',
      sortable: true,
      cellRenderer: (params: any) => (
        params.value === RoleType.PRICE ? (
          <span className='custom-page-css px-2 py-1 rounded text-FAAD14 border-FFE58F bg-FFFBE6 text-xs'>Giảm số tiền</span>
        ) : (
          <span className='custom-page-css px-2 py-1 rounded text-52C41A border-B7EB8F bg-F6FFED text-xs'>Giảm phần trăm</span>
        )
      ),
    },

    {
      headerName: 'Phần trăm/ Số tiền giảm',
      valueFormatter: (params) => {
        const row = params.data;

        return row?.role === RoleType.PERCENT
          ? `${params.value}%`
          : `${formatPrice(params.value)} đ`;
      },
      valueGetter: (params) =>
        params.data?.role === RoleType.PERCENT
          ? params.data?.percentDecrease
          : params.data?.reducedAmount,
      sortable: true,
    },

    {
      headerName: 'Đơn vị phát hành',
      field: 'issuedUnit',
      sortable: true,
    },
    {
      headerName: 'Đơn vị áp dụng',
      field: 'appliedUnits',
      sortable: true,
    },
    {
      headerName: 'Thương hiệu áp dụng',
      field: 'appliedBrands',
      sortable: true,
    },
    {
      headerName: 'Hoạt động áp dụng',
      field: 'appliedActivities',
      sortable: true,
    },
    {
      headerName: 'Đơn vị duyệt chương trình voucher',
      field: 'approvedUnit',
      sortable: true,
    },
    {
      headerName: 'Giá trị đơn hàng tối thiểu',
      field: 'orderValueMin',
      sortable: true,
      cellRenderer: (params: any) => (
        <span>{formatNumber(params.value)}</span>
      ),
    },
    {
      headerName: 'Số tiền giảm tối đa',
      field: 'reducedAmountMaximum',
      sortable: true,
      cellRenderer: (params: any) => (
        <span>{formatNumber(params.value)}</span>
      ),
    },
  ], [navigate])

  useEffect(() => {
    gListVocherActive()

  }, [dataFilter])

  useEffect(() => {
    if (issuedUnitId) {
      const { dateStart, dateEnd } = dataFilterVoucher
      setDataFilter({
        name: "",
        date: [dateStart ?? "", dateEnd ?? ""]
      })

    }


  }, [issuedUnitId, dataFilterVoucher])

  return (
    <Layout contentClassName="">
      <BreadcrumbBlock
        items={[
          { title: <Link to="/">THACO AUTO CRM</Link>, },
          { title: 'Marketing', },
          { title: 'Quản lý Voucher', },
        ]}
        title='Quản lý Voucher'
      />

      <ModalDeleteManager
        isOpen={isModalnDelete}
        closeModal={closeModalDelete}
        onConfirm={onConfirmDelete}
        title='Bạn có chắc chắn xóa voucher này'
        titleDelete='Xóa voucher'
        content='Voucher và dữ liệu liên quan sẽ bị xóa vĩnh viễn không thể khôi phục'
      />

      <VoucherFilterBlock
        issuedUnitId={issuedUnitId}
        selectedTab={selectedTab}
        dataFilter={dataFilter}
        setDataFilter={setDataFilter}
        exportExcel={exportExcel}
      />
      <Fragment>
        {listVoucherActive.length === 0 ? (
          <div

            className={`${getPermissionClass(add)} voucher-cards empty`}
          >
            <EmptyComponent content="">
              <span className="neutral-gray-500">Bạn chưa tạo Voucher nào, thử&nbsp;
                <Link
                  to="/marketing/vouchers-management/add"
                  className="primary-7"
                  style={{ textDecoration: "underline" }}
                >tạo mới ngay</Link>
              </span>
            </EmptyComponent>
          </div>
        ) : (
          <>
            <div className="ag-theme-alpine empty-test-td custom-table-ag-v2 pt-2" style={{ width: '100%' }}>
              <AgGridReact
                domLayout="autoHeight"
                rowData={listVoucherActive}
                columnDefs={columnDefs}
                defaultColDef={{ resizable: true }}
                rowHeight={55}
                suppressDragLeaveHidesColumns={true}
                getRowStyle={(params: any) => {
                  if (params?.node?.rowIndex % 2 === 0) return { backgroundColor: '#ffffff' }
                  return { backgroundColor: '#f7f9fc' }
                }}
              />
            </div>
            <ConfigProvider locale={viVN}>
              <div className="pagination-block mt-auto">
                <Pagination
                  showSizeChanger
                  current={paginationActive.current}
                  pageSize={paginationActive.pageSize}
                  total={paginationActive.total}
                  itemRender={(page, type, originalElement) => {
                    if (type === 'page') {
                      return <span>{formatNumber(page)}</span>;
                    }
                    return originalElement;
                  }}
                  showTotal={() => `Tổng cộng ${dataPagination(paginationActive.total, paginationActive.pageSize, paginationActive.current).totalPage} trang`}
                  className='rs-pagination'
                  onChange={onPaginationChangeActive}
                />
              </div>
            </ConfigProvider>
          </>
        )}
      </Fragment>
    </Layout>
  );
}

export default VouchersManagement;
